// extracted by mini-css-extract-plugin
export var avatarContainer = "_4u-0";
export var avatarTypingWave = "_4u-i";
export var gray = "_4u-f";
export var green = "_4u-c";
export var icon = "_4u-9";
export var image = "_4u-1";
export var lg = "_4u-6";
export var md = "_4u-5";
export var presenceDot = "_4u-b";
export var red = "_4u-d";
export var sm = "_4u-4";
export var status = "_4u-a";
export var typingDot = "_4u-h";
export var typingPill = "_4u-g";
export var xl = "_4u-7";
export var xs = "_4u-3";
export var xxl = "_4u-8";
export var xxs = "_4u-2";
export var yellow = "_4u-e";